import React, { useState, useEffect } from "react";
import { Layout as AntLayout, Menu, Button } from "antd";
import { useLocation, useNavigate } from "react-router";
import { useMenu, useLogout, Authenticated } from "@refinedev/core";
import { Header } from "./Header";
import { LogoutOutlined } from "@ant-design/icons";
import { Outlet, Navigate } from "react-router";
import { ThemedModal } from "./ThemedModal";
import { tenantService } from "../services/tenantService";

const { Sider } = AntLayout;

export const AuthenticatedLayout: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { menuItems: refineMenuItems } = useMenu();
  const { mutate: logout } = useLogout();
  const [tenantKey, setTenantKey] = useState(tenantService.getCurrentTenant().id);

  useEffect(() => {
    const unsubscribe = tenantService.subscribe(() => {
      setTenantKey(tenantService.getCurrentTenant().id);
    });

    return () => {
      unsubscribe();
    };
  }, []);

  const menuItems = refineMenuItems.map((item) => ({
    key: item.meta?.url || item.key,
    icon: item.meta?.icon,
    label: item.meta?.label,
  }));

  return (
    <Authenticated key="protected" fallback={<Navigate to="/login" />}>
      <AntLayout style={{ minHeight: "100vh" }}>
        <Header />
        <AntLayout>
          <Sider
            width={250}
            style={{
              background: "#fff",
              borderRight: "1px solid #f0f0f0",
              overflow: "auto",
              height: "calc(100vh - 80px)",
              position: "fixed",
              left: 0,
              top: 80,
              bottom: 0,
              paddingTop: "48px",
            }}
          >
            <Menu
              mode="inline"
              selectedKeys={[location.pathname]}
              style={{
                height: "calc(100% - 64px)",
                borderRight: 0,
              }}
              items={menuItems}
              onClick={({ key }) => navigate(key)}
            />
            <Button
              type="text"
              icon={<LogoutOutlined />}
              onClick={() => {
                ThemedModal.confirm({
                  title: "Abmelden bestätigen",
                  content: "Möchten Sie sich wirklich abmelden?",
                  okText: "Ja, abmelden",
                  cancelText: "Abbrechen",
                  onOk: () => logout(),
                });
              }}
              style={{
                position: "absolute",
                bottom: 48,
                left: "50%",
                transform: "translateX(-50%)",
                width: "95%",
                height: "40px",
                textAlign: "left",
                paddingLeft: "24px",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
              }}
            >
              Abmelden
            </Button>
          </Sider>
          <AntLayout style={{ marginLeft: 250, padding: 24 }}>
            <Outlet key={tenantKey} />
          </AntLayout>
        </AntLayout>
      </AntLayout>
    </Authenticated>
  );
};
